import React from "react";
import { Box, Typography } from "@mui/material";
import { useEditBookingContext } from "../EditBookingContext";

const EditBookingHeader: React.FC = () => {
  const { classes } = useEditBookingContext();

  return (
    <Box className={classes.titlesBoxStyle}>
      <Typography className={classes.typography} variant="h6">
        Edit Unit Properties
      </Typography>
    </Box>
  );
};

export default EditBookingHeader;
